import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DlgSuccessBuyComponent } from './dlg-success-buy';

@Injectable()
export class ShowDlgSuccessBuyService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show({ className, amount = 0, promo = false, innerHTML = null}): Promise<any> {
        const dialogRef = this._dialog.open(DlgSuccessBuyComponent, {
            panelClass: ['--ui'],
            data: {
                className,
                amount,
                promo,
                innerHTML
            }
        });

        const source = dialogRef.afterClosed();

        return source.toPromise();
    }
}
